import './style.scss';
import { InputAdvisability } from 'views/components/molecules/establishes/inputAdvisability';
import {
  DepositAccountFormikType,
  DEPOSIT_TYPE,
  getDepositType,
  FormErrorScrollTarget,
} from 'views/utils/accountEstablish';
import { Button, ButtonProps, ButtonSize, FillType } from 'views/components/atoms/button';
import { EstablishError } from 'views/components/atoms/establishes/error';
import { EstablishHeader } from 'views/components/atoms/establishes/header';
import { EstablishText } from 'views/components/atoms/establishes/text';
import { InputBankModal } from '../../InputBankModal';
import { useState } from 'react';
import { EstablishRadio } from 'views/components/atoms/establishes/radio';

type DepositAccountTemplateType = {
  formik: DepositAccountFormikType;
  buttonProps?: {
    nextButtonProps: ButtonProps;
    prevButtonProps: ButtonProps;
    confirmButtonProps: ButtonProps;
    isPrevPageConfirm: boolean;
  };
};

export const DepositAccountTemplate = ({ formik, buttonProps }: DepositAccountTemplateType) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isYuchoBank, setIsYuchoBank] = useState(formik.values.bankCode === '9900');
  return (
    <>
      <InputBankModal
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        setBankInfo={(bankName: string, bankCode: string, branchName: string, branchCode: string) => {
          setIsYuchoBank(bankCode === '9900');
          formik.setFieldValue('bankName', bankName);
          formik.setFieldValue('bankCode', bankCode);
          formik.setFieldValue('branchName', branchName);
          formik.setFieldValue('branchCode', branchCode);
        }}
      />
      <div className="establishWrapper hiddenBg depositAccountTemplate">
        <div className="establishWrapper_announce">
          <h1>指定預金口座</h1>
        </div>

        <div className="bankInfo">
          <div className="bankInfo_inputWrapper">
            {(!!formik.errors.bankCode ||
              !!formik.errors.bankName ||
              !!formik.errors.branchCode ||
              !!formik.errors.branchName) && <FormErrorScrollTarget />}
            <EstablishHeader headerTitle={'金融機関名'} batchDangerWord="必須" />
            <span className="bankLabel">{formik.values.bankName}</span>
            <EstablishHeader headerTitle={'支店名'} batchDangerWord="必須" />
            <span className="bankLabel">{formik.values.branchName}</span>
            {/* 金融機関名or支店名片方だけのエラーは基本ありえないが念ため入れておく */}
            {!!formik.errors.bankCode ? (
              <EstablishError isEnabled={!!formik.errors.bankCode} errorText={formik.errors.bankCode} />
            ) : !!formik.errors.bankName ? (
              <EstablishError isEnabled={!!formik.errors.bankName} errorText={formik.errors.bankName} />
            ) : !!formik.errors.branchCode ? (
              <EstablishError isEnabled={!!formik.errors.branchCode} errorText={formik.errors.branchCode} />
            ) : !!formik.errors.branchName ? (
              <EstablishError isEnabled={!!formik.errors.branchName} errorText={formik.errors.branchName} />
            ) : null}
          </div>
          <Button
            label="金融機関名検索"
            buttonSize={ButtonSize.sizeS}
            fillType={FillType.primaryFill}
            onClick={() => setIsOpen(true)}
          />
        </div>

        <div className="inputWrapper">
          {!!formik.errors.accountNumber && <FormErrorScrollTarget />}
          <EstablishHeader headerTitle={'口座番号'} batchDangerWord="必須" />
          <EstablishText
            inputType="tel"
            inputValue={formik.values.accountNumber ?? undefined}
            setInputValue={(e) => formik.setFieldValue('accountNumber', e.target.value)}
            placeholder="例:1234567"
          />
          <span className="establishWrapper_description">※口座名義は本登録と同じ本人名義に限ります</span>
          <EstablishError isEnabled={!!formik.errors.accountNumber} errorText={formik.errors.accountNumber} />
        </div>
        {!!formik.errors.depositForm && <FormErrorScrollTarget />}

        {isYuchoBank ? (
          <div className="inputWrapper">
            <EstablishHeader headerTitle={'預金種目'} batchDangerWord={'必須'} />
            <EstablishRadio
              key={'agree'}
              name={'depositForm'}
              text={'普通預金'}
              value={'true'}
              checked={formik.values.depositForm === DEPOSIT_TYPE.NORMAL}
              onChange={(checked) =>
                formik.setFieldValue('depositForm', checked ? DEPOSIT_TYPE.NORMAL : DEPOSIT_TYPE.SAVING)
              }
            />
            <EstablishError isEnabled={!!formik.errors.depositForm} errorText={formik.errors.depositForm} />
          </div>
        ) : (
          <InputAdvisability
            title="預金種目"
            name="depositForm"
            batchDangerWord="必須"
            agreeText="普通（総合）"
            denialText="当座"
            agreeValue="true"
            denialValue="false"
            checked={getDepositType(formik.values.depositForm)}
            onChange={(checked) =>
              formik.setFieldValue('depositForm', checked ? DEPOSIT_TYPE.NORMAL : DEPOSIT_TYPE.SAVING)
            }
            isEnabled={!!formik.errors.depositForm}
            errorText={formik.errors.depositForm}
          />
        )}
      </div>
      {buttonProps && (
        <div className="establishWrapper">
          {buttonProps.isPrevPageConfirm ? (
            <div className="establishWrapper_buttons">
              <Button {...buttonProps.confirmButtonProps} />
            </div>
          ) : (
            <div className="establishWrapper_buttons">
              <Button {...buttonProps.prevButtonProps} />
              <Button {...buttonProps.nextButtonProps} />
            </div>
          )}
        </div>
      )}
    </>
  );
};
